module.exports = __webpack_public_path__ + "img/8372aa4ea03fdc8d5b9fd12d7d0fb6f5.2e3874df.jpg";